var _rect, _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTaxIdIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "#ECF1F7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.2919 12.1045H10.7077C9.70307 12.1045 8.88867 12.9189 8.88867 13.9235V26.0763C8.88867 27.0809 9.70307 27.8953 10.7077 27.8953H29.2919C30.2965 27.8953 31.1109 27.0809 31.1109 26.0763V13.9235C31.1109 12.9189 30.2965 12.1045 29.2919 12.1045Z",
    stroke: "#333333",
    strokeWidth: 1.11111,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4446 20.6362C15.6377 20.6362 16.6049 19.6689 16.6049 18.4758C16.6049 17.2827 15.6377 16.3154 14.4446 16.3154C13.2514 16.3154 12.2842 17.2827 12.2842 18.4758C12.2842 19.6689 13.2514 20.6362 14.4446 20.6362Z",
    stroke: "#333333",
    strokeWidth: 0.925926,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.8548 20.1732H28.7187M11.7098 24.3018H17.6416C17.7485 24.3021 17.8532 24.2716 17.9433 24.2141C18.0334 24.1566 18.1051 24.0744 18.1498 23.9773C18.1945 23.8802 18.2104 23.7723 18.1956 23.6664C18.1807 23.5605 18.1357 23.4612 18.066 23.3801C17.6585 22.8728 17.1423 22.4634 16.5556 22.1821C15.9688 21.9008 15.3264 21.7548 14.6757 21.7548C14.025 21.7548 13.3825 21.9008 12.7958 22.1821C12.209 22.4634 11.6929 22.8728 11.2853 23.3801C11.2156 23.4612 11.1707 23.5605 11.1558 23.6664C11.1409 23.7723 11.1568 23.8802 11.2015 23.9773C11.2463 24.0744 11.3179 24.1566 11.408 24.2141C11.4981 24.2716 11.6029 24.3021 11.7098 24.3018V24.3018ZM22.8548 18.0898H27.0986H22.8548ZM22.8548 22.2566H27.0986H22.8548Z",
    stroke: "#333333",
    strokeWidth: 0.925926,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTaxIdIcon);
export default __webpack_public_path__ + "static/media/TaxIdIcon.3f1b29f7c14088a7804cffd6c69acba2.svg";
export { ForwardRef as ReactComponent };